import { BaseMapper } from '@ps/utils';
import {
  TemplateFolder,
  TemplateSummary,
  TEMPLATE_TYPE,
} from '@ps/survey-utils';

import { TemplateFolderDto, TemplateSummaryDto } from '../dtos/template.dto';

export class TemplateFolderMapper extends BaseMapper<
  TemplateFolderDto,
  TemplateFolder
> {
  public fromDto(dto: TemplateFolderDto): TemplateFolder {
    return {
      id: dto.id,
      name: dto.name,
      templates:
        dto.templates?.map((summary) => this._fromSummaryDto(summary)) ?? [],
      subfolders: dto.subfolders?.map((subfolder) => this.fromDto(subfolder)),
    };
  }

  private _fromSummaryDto(dto: TemplateSummaryDto): TemplateSummary {
    return {
      id: dto.id,
      name: dto.name,
      type: dto.is_mc_template
        ? TEMPLATE_TYPE.MULTI_COUNTRY
        : TEMPLATE_TYPE.SINGLE_COUNTRY,
      isDefault: dto.is_default ?? false,
      isOwner: dto.is_owner ?? false,
      hasSuppliersList: !!dto.is_suppliers_list,
      isServiceBuyer: !!dto.is_service_buyer,
    };
  }
}
